<template>
  <transition name="toast-fade">
    <div v-if="visible" :class="['toast', `toast-${type}`]">
      <div class="toast-icon">
        <span v-if="type === 'error'">✕</span>
        <span v-else-if="type === 'warning'">⚠</span>
        <span v-else-if="type === 'success'">✓</span>
      </div>
      <div class="toast-message">{{ message }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Toast',
  data() {
    return {
      visible: false,
      message: '',
      type: 'error', // 'error' | 'warning' | 'success'
      duration: 3000, // 默认 3 秒
      timer: null
    }
  },
  methods: {
    /**
     * 显示提示消息
     * @param {Object} options - 配置选项
     * @param {string} options.message - 提示消息内容
     * @param {string} options.type - 提示类型：'error' | 'warning' | 'success'
     * @param {number} options.duration - 显示时长（毫秒），默认 3000ms
     */
    show(options) {
      // 如果已经有提示在显示，先清除
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }

      // 设置新的提示内容
      this.message = options.message || ''
      this.type = options.type || 'error'
      this.duration = options.duration || 3000
      this.visible = true

      // 设置自动隐藏
      this.timer = setTimeout(() => {
        this.hide()
      }, this.duration)
    },

    /**
     * 隐藏提示消息
     */
    hide() {
      this.visible = false
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
</script>

<style scoped lang="scss">
.toast {
  position: fixed;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  min-width: 300px;
  max-width: 500px;
  backdrop-filter: blur(10px);
  
  .toast-icon {
    font-size: 20px;
    font-weight: bold;
    flex-shrink: 0;
  }
  
  .toast-message {
    font-size: 14px;
    line-height: 1.5;
    word-break: break-word;
  }
  
  // 错误样式
  &.toast-error {
    background: rgba(255, 77, 79, 0.95);
    border: 1px solid rgba(255, 77, 79, 0.8);
    color: #fff;
    
    .toast-icon {
      color: #fff;
    }
  }
  
  // 警告样式
  &.toast-warning {
    background: rgba(255, 193, 7, 0.95);
    border: 1px solid rgba(255, 193, 7, 0.8);
    color: #333;
    
    .toast-icon {
      color: #333;
    }
  }
  
  // 成功样式
  &.toast-success {
    background: rgba(76, 175, 80, 0.95);
    border: 1px solid rgba(76, 175, 80, 0.8);
    color: #fff;
    
    .toast-icon {
      color: #fff;
    }
  }
}

// 过渡动画
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: all 0.3s ease;
}

.toast-fade-enter {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}

.toast-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}
</style>
